module.exports = __webpack_public_path__ + "img/pc_banner_terms.1ad62c29.png";